import { useTranslation } from '@/i18n/useTranslation';

import { Link } from 'react-router-dom';

export function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <div className="forbidden-panel glass-panel" role="alert">
      <h1>{t('403 — Forbidden')}</h1>
      <p>
        {t("You don't have permission to view this page. This area is restricted to Admin users.")}
      </p>
      <Link to="/" className="btn btn--primary">
        {t('Back to Dashboard')}
      </Link>
    </div>
  );
}
